export function SET_ZONE_SELECTED(state, zone) {
  state.zoneSelected = zone;
}
